<template>
  <v-dialog max-width="650px" v-model="showEditLocation">
    <template v-slot:activator="{}">
      <v-card
        class="ma-3 pa-2"
        outlined
        max-width="230px"
        style="width:220px;  float: left;margin:10px 10px 10px 10px;"
        @click="openEditLocation"
      >
        <!-- <div class="d-none" sty>
          {{ $t("Scan and Order!") }}
        </div>-->
        <vue-qr style="width:200px;" :logoSrc="logo" :text="qrUrl" :id="index" :size="600" />
        <!-- <div>
          {{ $t("http://MerloCode.com") }}
        </div>-->
        <v-card-title class="d-flex justify--center">{{ location.name }}</v-card-title>
        <v-card-subtitle class="d-flex justify--end">
          <v-spacer />
          <!-- <v-icon color="primary" v-if="location.isNotified">
            mdi-bell-check-outline
          </v-icon>
          <v-icon v-else>mdi-bell-outline</v-icon>-->
          <v-icon
            color="primary"
            v-if="location.isTakeAway"
            :disabled="$store.getters.canOrder"
          >mdi-truck-fast-outline</v-icon>
          <v-icon v-else :disabled="$store.getters.canOrder">mdi-truck-fast-outline</v-icon>
        </v-card-subtitle>
      </v-card>
    </template>
    <EditLocation
      :location="location"
      :logo="logo"
      :index="index"
      @closeEditLocation="closeEditLocation"
    />
  </v-dialog>
</template>

<script>
import VueQr from "vue-qr";
import EditLocation from "@/views/dashboard/components/locations/EditLocation";

export default {
  props: ["location", "logo", "index"],
  components: {
    VueQr,
    EditLocation
  },
  data() {
    return { showEditLocation: false };
  },

  computed: {
    qrUrl() {
      return this.location.codeId
        ? `https://bell.merlocode.com/${this.location.codeId}`
        : "https://i.giphy.com/media/RX3vhj311HKLe/giphy.webp";
    }
  },

  methods: {
    openEditLocation() {
      this.showEditLocation = true;
    },
    closeEditLocation() {
      this.showEditLocation = false;
    }
  }
};
</script>

<style></style>
